module.exports = __webpack_public_path__ + "img/cloudcheckr.04babcfc.png";